import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@consigli/shadcn';

interface ActionButtonProps {
  icon: React.ReactNode;
  actions: {
    label: string;
    onClick: () => void;
    disabled?: boolean;
    destructive?: boolean;
  }[];
}

export const ActionButton = ({ icon, actions }: ActionButtonProps) => {
  return (
    <span onClick={(e) => e.stopPropagation()} role="presentation">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button className="p-2 hover:bg-gray-200 rounded hover:cursor-pointer">{icon}</button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {actions.map((action) => (
            <DropdownMenuItem
              key={action.label}
              onSelect={action.onClick}
              disabled={action.disabled}
              variant={action.destructive ? 'destructive' : 'default'}
            >
              {action.label}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </span>
  );
};
